import { render, staticRenderFns } from "./edit-password.vue?vue&type=template&id=35dc9c1a&scoped=true&"
import script from "./edit-password.vue?vue&type=script&lang=js&"
export * from "./edit-password.vue?vue&type=script&lang=js&"
import style0 from "./edit-password.vue?vue&type=style&index=0&id=35dc9c1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dc9c1a",
  null
  
)

export default component.exports